var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"center"},style:({height:_vm.innerHeight-314+'px'})},[_c('div',{staticClass:"blank40"}),_c('div',{staticClass:"blank40"}),_c('div',{staticClass:"blank40"}),_c('span',[_vm._v("暂无权限")])])}
var staticRenderFns = []

export { render, staticRenderFns }